import { jsxs as e, jsx as L } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2359.js";
function i({ size: C = l }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ L("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ L(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.2273 40.8764C36.1262 40.8764 36.0251 40.8555 35.9324 40.8136L28.0007 37.2523L20.069 40.8136C19.9749 40.8555 19.8738 40.8764 19.7726 40.8764C19.6322 40.8764 19.4918 40.8345 19.3724 40.7546C19.1702 40.6172 19.0649 40.3867 19.0972 40.155L20.2796 32.023L15.1887 26.0907C15.0159 25.9218 14.9559 25.6782 15.0332 25.4557C15.1118 25.2331 15.316 25.0681 15.5618 25.0262L23.2287 23.5611L27.3996 16.3339C27.519 16.1283 27.7493 16 28.0007 16C28.2507 16 28.481 16.1283 28.6004 16.3339L32.7727 23.5611L40.4382 25.0262C40.6854 25.0681 40.8882 25.2331 40.9668 25.4557C41.0441 25.6782 40.9841 25.9218 40.8113 26.0907L35.7204 32.023L36.9028 40.155C36.9351 40.3867 36.8312 40.6172 36.6276 40.7546C36.5096 40.8345 36.3692 40.8764 36.2273 40.8764Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0007 36.1561L35.8214 39.6676L34.6653 31.7169L39.6609 25.8957L32.1354 24.4574L28 17.2941L23.8661 24.4574L16.3391 25.8958L21.3346 31.7169L20.1785 39.6682L28.0007 36.1561ZM19.0972 40.155L20.2796 32.023L15.1887 26.0907C15.0159 25.9218 14.9559 25.6782 15.0332 25.4557C15.1118 25.2331 15.316 25.0681 15.5618 25.0262L23.2287 23.5611L27.3996 16.3339C27.519 16.1283 27.7493 16 28.0007 16C28.2507 16 28.481 16.1283 28.6004 16.3339L32.7727 23.5611L40.4382 25.0262C40.6854 25.0681 40.8882 25.2331 40.9668 25.4557C41.0441 25.6782 40.9841 25.9218 40.8113 26.0907L35.7204 32.023L36.9028 40.155C36.9351 40.3867 36.8312 40.6172 36.6276 40.7546C36.5096 40.8345 36.3692 40.8764 36.2273 40.8764C36.1262 40.8764 36.0251 40.8555 35.9324 40.8136L28.0007 37.2523L20.069 40.8136C19.9749 40.8555 19.8738 40.8764 19.7726 40.8764C19.6322 40.8764 19.4918 40.8345 19.3724 40.7546C19.1702 40.6172 19.0649 40.3867 19.0972 40.155Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricFavoritesIcon
};
//# sourceMappingURL=index.es390.js.map
